import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IRootState, IRootThunkDispatch } from '../../redux/store';
import { Grid, TextField } from '@mui/material';
import { changeTargetBinPeopleCounterAction } from '../../redux/peopleCounter/action';

function PeopleCounterForm() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const [counterValue, setCounterValue] = useState('');

  const { targetBinPeopleCounter } = useSelector(
    (state: IRootState) => state.peopleCounterState
  );

  useEffect(() => {
    setCounterValue(targetBinPeopleCounter.bin_people_counter.toString());
  }, [targetBinPeopleCounter.bin_people_counter_id]);

  function handleChangeBinPeopleCounter(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    if (value === '' || !isNaN(Number(value))) {
      const cleaned = value === '' ? '' : Number(value).toString();
      setCounterValue(cleaned);
      if (cleaned !== '') {
        dispatch(changeTargetBinPeopleCounterAction(Number(cleaned)));
      }
    }
  }

  return (
           <Grid style={{ display: "flex", flexDirection: "row", gap: 30 }}>
                <Grid style={{ flex: 1 }}>
                  <TextField
                    id="outlined-required"
                    placeholder="請輸入廁所組合名稱"
                    value={targetBinPeopleCounter.bin_full_name}
                    fullWidth
                    label="廁所名稱(中文)"
                    disabled
                  />
                </Grid>
                <Grid style={{ flex: 1 }}>
                  <TextField
                    id="outlined-required"
                    placeholder="請輸入人流統計器"
                    value={counterValue}
                    fullWidth
                    label="更改人流統計器"
                    type="number"
                    onChange={handleChangeBinPeopleCounter}
                  />
                </Grid>
            </Grid>
  )
}

export default PeopleCounterForm